import { useState } from 'react';

import { LegalDisclaimer } from '@playbooks/components/auth/legal-disclaimer';
import { RegisterFields } from '@playbooks/components/auth/register-fields';
import { GithubAuthBtn } from '@playbooks/components/github/github-auth-btn';
import { GoogleAuthBtn } from '@playbooks/components/google/google-auth-btn';
import { useStore } from '@playbooks/contexts';
import { useAction } from '@playbooks/hooks';
import { Button } from '@playbooks/ui/components/button';
import { DialogFooter, DialogHeader, DialogTitle } from '@playbooks/ui/components/dialog';
import { Icon } from '@playbooks/ui/components/icon';
import { Separator } from '@playbooks/ui/components/separator';

const AuthFlowRegister = ({ open, setOpen, onClose, onView, onNext }) => {
	const [user, setUser] = useState<any>({});
	const store = useStore();

	// Actions
	const [onSave, saveTask] = useAction(async () => {
		const response = await store.createRecord({ url: '/auth/register', data: user });
		await onNext(response.data);
	});

	const onSubmit = e => {
		e.preventDefault();
		onSave();
	};

	// Render
	return (
		<form onSubmit={onSubmit}>
			<DialogHeader>
				<Button type='button' variant='outline' size='icon-xs' aria-label='Back' onClick={() => onView('welcome')}>
					<Icon type='far' icon='chevron-left' aria-hidden />
				</Button>
				<DialogTitle>Create your account</DialogTitle>
			</DialogHeader>
			<div>
				<RegisterFields user={user} setUser={setUser} />
			</div>
			<DialogFooter className='gap-2 flex-column'>
				<Button type='submit' size='lg' isLoading={saveTask.running} className='w-full'>
					Create account
				</Button>
				<div className='flex-middle gap-3 text-xs text-foreground-subtle'>
					<Separator />
					<span className='shrink-0'>or continue with</span>
					<Separator />
				</div>
				<div className='grid grid-cols-2 gap-2'>
					<GoogleAuthBtn variant='outline' size='default' onNext={onNext}>
						Google
					</GoogleAuthBtn>
					<GithubAuthBtn variant='outline' size='default' onNext={onNext}>
						GitHub
					</GithubAuthBtn>
				</div>
				<LegalDisclaimer />
			</DialogFooter>
		</form>
	);
};

export { AuthFlowRegister };
